<template lang="pug">
div
  v-card(flat)
    v-card-title Location Impact
    keep-alive
      validation-observer(ref="o11" v-slot="{ invalid }" :persist="true" vid="o11")
        v-container
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will streets, lanes, public or metered parking spaces, public parking, sidewalks, businesses and/or County facilities be impacted by the event?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_DIS_Bool" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will any on-street or metered parking space restrictions be needed during the event? (for event logistics and public safety purposes only)
              v-radio-group(v-model="SEA_DIS_Parking" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row(v-if="SEA_DIS_Bool === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Impact Locations &amp; Times
              p.pb-0.pl-8.text--secondary Describe the times and locations where impact(s) will occur. For streets, lanes, public parking or sidewalks, include the first and last intersection, for example "Campbell Street between S Arlington Mill and S Randolph" or "Army Navy Drive, between and including S 23rd and S Joyce". <strong>These impacts must also be noted on your site plan map.</strong>
              p.pb-0.pl-8.text--secondary <strong>Impact Types:</strong> Pedestrian, Bike, Vehicular, Parking, Public Transit, Facility, Utility
              p.pb-0.pl-8.text--secondary <strong>Extent Types:</strong> Partial, Full
              p.pb-0.pl-8.text--secondary <strong>Example:</strong>
              ul
                li Vehicular, 8am, 9am, Campbell Street between S. Arlington Mill and S. Randolph, Full
                li Vehicular, 8:30am-9:30am, Army Navy Drive between and including S. 23rd and S. Joyce, Full
          v-row(v-if="SEA_DIS_Bool === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Impact List
              p.pb-0.pl-8.text--secondary List each impact and the type, start time, end time, location/name, and extent.
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              v-container
                v-row(v-for="event in SEA_DIS_List", :key="event.id")
                  v-col(:lg="11", :md="11", :sm="11")
                    v-row
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(rules="required", v-slot="{ errors }" immediate)
                          v-select.pb-3.pl-3(
                            :items="col_dis_type",
                            item-value="id",
                            solo,
                            attach,
                            v-model="event.dis_type",
                            :disabled="disabled"
                            label="Type"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(rules="required", v-slot="{ errors }" immediate)
                          v-datetime-picker(
                            label="Start Time",
                            v-model="event.dis_StartTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(rules="required", v-slot="{ errors }" immediate)
                          v-datetime-picker(
                            label="End Time",
                            v-model="event.dis_EndTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(rules="required", v-slot="{ errors }" immediate)
                          v-text-field.pb-3.pl-3(
                            label="Location",
                            outlined,
                            hide-details,
                            dense,
                            v-model="event.dis_Location",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                        validation-provider(rules="required", v-slot="{ errors }" immediate)
                          v-select.pb-3.pl-3(
                            :items="col_dis_Extent",
                            item-value="id",
                            solo,
                            attach,
                            v-model="event.dis_Extent",
                            :disabled="disabled"
                            label="Extent"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                  v-col(:lg="1", :md="1", :sm="1")
                    v-btn.mx-2(fab, small, @click="removeEvent(event.id)") 
                      v-icon mdi-minus
                  v-col(:lg="12", :md="12", :sm="12", :cols="12" v-if="event.dis_EndTime < event.dis_StartTime")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your impact start must be before your end time.
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              v-btn.mx-2(fab, small, color="primary", @click="addEvent()")
                v-icon mdi-plus
              span Add an impact
          v-row(v-if="SEA_DIS_Bool === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Street Closure Instructions
              p.pb-0.pl-8.text--secondary Contact the Arlington County Police Department Special Operations Section at 703-228-4259 to review the street closures.
              p.pb-0.pl-8.text--secondary A <a target="_blank" href="https://topics.arlingtonva.us/permits-licenses/transportation-right-way-permit-guide/">transportation right-of-way (TROW) permit</a> is required for any activities that require street closure, use of travel lanes, use of parking meters, installation of temporary &quot;No Parking&quot; signs or barricades as a part of a permit request. Permits cost $34.00.
              p.pb-0.pl-8.text--secondary In accordance with the County Code the following fees are charged:
              ul
                li $15.00 per meter per day for parking meters
                li $25.00 for the first two &quot;No Parking&quot; signs and $1.25 for each additional &quot;No Parking&quot; sign
                li $5.00 per device per day for traffic control devices (barricades/barrels)
              p.pb-0.pl-8.text--secondary Contact Traffic Engineering at least 10 business days prior to the event at 703-228-7578 to obtain permits and pay fees.
</template>


<script>
import { mapState } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import store from "../store";
import moment from "moment";

let thirtyDaysAhead = moment().add(30, "days");
thirtyDaysAhead = moment(thirtyDaysAhead).format("YYYY-MM-DDThh:mm:ss");

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_DIS_Bool",
      "data.SEA_DIS_Parking",
      "data.disabled",
    ]),
    ...mapMultiRowFields(["data.SEA_DIS_List"]),
  },
  data() {
    return {
      // functions to limit dates:
      //https://darrenfang.github.io/vuetify-datetime-picker/
      //https://github.com/darrenfang/vuetify-datetime-picker/blob/master/src/app.vue
      dateProps: {
        min: thirtyDaysAhead,
        showCurrent: thirtyDaysAhead,
      },
      timeProps: {
        ampmInTitle: false,
      },
      col_dis_type: [
        "Pedestrian",
        "Vehicular",
        "Parking",
        "Public Transit",
        "Facility",
        "Utility",
      ],
      col_dis_Extent: [
        "Partial",
        "Full"
      ]
    };
  },
  methods: {
    addEvent() {
      let nextIndex = this.data.SEA_DIS_List.length;
      if (nextIndex < 15) {
        this.data.SEA_DIS_List.push({
          id: nextIndex,
          dis_type: undefined,
          dis_StartTime: undefined,
          dis_EndTime: undefined,
          dis_Location: undefined,
          dis_Extent: undefined,
        });
      } else {
        // show message
      }
    },
    removeEvent(event) {
      this.data.SEA_DIS_List.splice(event, 1);
    },
    //
  },
};
</script>